import { ActionType } from '../constants/ActionTypes';
import { RestPath } from '../constants/SitePaths';
import axios from 'axios';
import Constants from '../constants/Constants';
import config from '../constants/Configs';
import { LanguageService } from '../services/LanguageService';
import { Auth } from '../services/Auth';
import { Browser } from '../services/helpers/Browser';
import NotificationService from '../components/base/notifications/NotificationService';
import qs from 'qs';
import store from '../'
// Get Page
export const getPageBegin = () => ({
  type: ActionType.GET_PAGE_BEGIN
});

export const getPageSuccess = data => ({
  type: ActionType.GET_PAGE_SUCCESS,
  payload: data
});

export const getPageError = (error) => ({
  type: ActionType.GET_PAGE_ERROR,
  payload: error
});

// Get BACKGROUNDS
export const getBackgroundsBegin = () => ({
  type: ActionType.GET_BACKGROUNDS_BEGIN
});

export const getBackgroundsSuccess = data => ({
  type: ActionType.GET_BACKGROUNDS_SUCCESS,
  payload: data
});

export const getBackgroundsError = (error) => ({
  type: ActionType.GET_BACKGROUNDS_ERROR,
  payload: error
});

// Get Bonus Campaign page

export const getBonusCampaignPageBegin = () => ({
  type: ActionType.GET_BONUS_CAMPAIGNS_PAGE_BEGIN,
});

export const getBonusCampaignPageError = (data) => ({
  type: ActionType.GET_BONUS_CAMPAIGNS_PAGE_ERROR,
  payload: data
});

export const getBonusCampaignPageSuccess = (data) => ({
  type: ActionType.GET_BONUS_CAMPAIGNS_PAGE_SUCCESS,
  payload: data
});

export const joinBonusCampaignPageBegin = () => ({
  type: ActionType.JOIN_BONUS_CAMPAIGNS_PAGE_BEGIN,
});

export const joinBonusCampaignPageError = (data) => ({
  type: ActionType.JOIN_BONUS_CAMPAIGNS_PAGE_ERROR,
  payload: data
});

export const joinBonusCampaignPageSuccess = (data) => ({
  type: ActionType.JOIN_BONUS_CAMPAIGNS_PAGE_SUCCESS,
  payload: data
});

/* Get Page */
export function getPage(params, bNotSave, isWidget) {
  const ln = isWidget ? '' : `?ln=${LanguageService.getSelectedLanguage()}`;
  const isAuthenticated = Auth.isAuthenticated();

  return dispatch => {
    if (!bNotSave) {
      dispatch(getPageBegin());
    }
    const targetGroups = store.getState().user?.playerData?.player?.targetGroups || {};
    if (targetGroups && Object.keys(targetGroups).length > 0) {
      let tagetGroupParam = {};
      Object.keys(targetGroups).forEach((key) => {
          if (targetGroups[key] && targetGroups[key].length > 0) {
              tagetGroupParam[key] = targetGroups[key];
          }
      });
      params = { ...params, ...tagetGroupParam };
    }
    return axios({
      method: Constants.GET,
      url: config.BASE_URL + RestPath.GET_PAGE + ln + `&a=${isAuthenticated}`,
      params,
      paramsSerializer: function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    }).then((response) => {
      if (!bNotSave || bNotSave && response.data && response.data.data && response.data.data.content) {
        dispatch(getPageSuccess(response.data));
      }
      return response.data;
    })
      .catch((error) => {
        if (error.response) {
          dispatch(getPageError(error.response.data));
        } else {
          dispatch(getPageError(error));
        }
      });
  };
}

/* Get BACKGROUNDS */
export function getBackgrounds(params) {
  const d = Browser.getHeaderDeviceType();

  return dispatch => {
    dispatch(getBackgroundsBegin());
    return axios({
      method: Constants.GET,
      url: config.BASE_URL + RestPath.GET_BACKGROUNDS,
      params: { d }
    }).then((response) => {
      dispatch(getBackgroundsSuccess(response.data));
    })
      .catch((error) => {
        if (error.response) {
          dispatch(getBackgroundsError(error.response.data));
        } else {
          dispatch(getBackgroundsError(error));
        }
      });
  };
}

export function getBonusCampaignPage(id) {
  return dispatch => {
    dispatch(getBonusCampaignPageBegin());
    return axios({
      method: Constants.GET,
      url: `${config.BASE_URL}${RestPath.BONUS_CAMPAIGN_PAGE}/${id}`,
    }).then((response) => {
      dispatch(getBonusCampaignPageSuccess({ data: response.data, id }));
      return response.data
    })
      .catch((error) => {
        dispatch(getBonusCampaignPageError(error?.response?.data));
      });
  };
}

export function joinBonusCampaign(id, showSuccessPopup = false) {
  return dispatch => {
    dispatch(joinBonusCampaignPageBegin());
    return axios({
      method: Constants.POST,
      url: `${config.BASE_URL}${RestPath.BONUS_CAMPAIGN_PAGE}/${id}/Join`,
    }).then((response) => {
      dispatch(joinBonusCampaignPageSuccess(response.data));
      if (showSuccessPopup) {
        NotificationService.success({ message:LanguageService.getTranslation('campaignText', 'offers')});
      }
      return response;
    }).catch((error) => {
      dispatch(joinBonusCampaignPageError(error.response.data));
      NotificationService.error({ message: error.response.data && error.response.data.message || LanguageService.getTranslation('genericErrorMsg') });
    });
  };
}